import {OrderStatus} from 'modules/orders/types';
import React from 'react';
import {FaMoneyBill, FaUserClock} from 'react-icons/fa';
import {GiFullMotorcycleHelmet} from 'react-icons/gi';
import {
  IoAlert,
  IoCheckmark,
  IoClose,
  IoFastFoodSharp,
  IoHome,
} from 'react-icons/io5';
import {MdDeliveryDining} from 'react-icons/md';
import {PiForkKnifeFill} from 'react-icons/pi';
import {useTheme} from 'styled-components';

interface Props {
  status: string;
}

const StatusIcon: React.FC<Props> = ({status}) => {
  const {colors} = useTheme();

  if (status === OrderStatus.awaiting_payment)
    return <FaMoneyBill color={colors.primary} />;
  if (status === OrderStatus.opened) return <IoAlert color={colors.primary} />;
  if (status === 'preparing') return <PiForkKnifeFill color={colors.primary} />;
  if (status === OrderStatus.ready_to_delivery)
    return <IoFastFoodSharp color={colors.primary} />;
  if (status === 'ready_to_pickup')
    return <FaUserClock color={colors.primary} />;
  if (
    status === OrderStatus.delivery_man_assigned ||
    status === OrderStatus.delivery_man_auto_assigned
  )
    return <GiFullMotorcycleHelmet color={colors.primary} />;
  if (status === 'delivering')
    return <MdDeliveryDining color={colors.primary} />;
  if (status === 'arrival') return <IoHome color={colors.primary} />;
  if (status === OrderStatus.finished)
    return <IoCheckmark color={colors.primary} />;
  if (status === OrderStatus.canceled)
    return <IoClose color={colors.primary} />;

  return null;
};

export default StatusIcon;
